import { Box, IconButton, Typography, Badge, TextField, InputAdornment, Tooltip } from '@mui/material';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import NotificationsNoneRoundedIcon from '@mui/icons-material/NotificationsNoneRounded';
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';
import KeyboardCommandKeyRoundedIcon from '@mui/icons-material/KeyboardCommandKeyRounded';
import { KeyboardEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const QUICK_LINKS = [
  { terms: ['tổng quan', 'dashboard'], to: '/' },
  { terms: ['đơn nợ', 'phiếu nợ'], to: '/debtSlips' },
  { terms: ['hóa đơn', 'vat'], to: '/vatInvoices' },
  { terms: ['lệnh chi', 'thanh toán'], to: '/paymentOrders' },
  { terms: ['nhà cung cấp', 'ncc'], to: '/suppliers' },
  { terms: ['cài đặt', 'settings'], to: '/settings' },
];

const QuickSearch = () => {
  const navigate = useNavigate();
  const [value, setValue] = useState('');

  const go = () => {
    const q = value.trim().toLocaleLowerCase('vi');
    if (!q) return;
    const match = QUICK_LINKS.find((x) => x.terms.some((term) => term.includes(q) || q.includes(term)));
    if (match) {
      navigate(match.to);
      setValue('');
    }
  };

  const onKeyDown = (e: KeyboardEvent<HTMLElement>) => {
    if (e.key === 'Enter') go();
  };

  return (
    <TextField
      value={value}
      onChange={(e) => setValue(e.target.value)}
      onKeyDown={onKeyDown}
      placeholder="Tìm nhanh trang..."
      aria-label="Tìm nhanh trang"
      sx={{
        width: 290,
        display: { xs: 'none', lg: 'block' },
        '& .MuiOutlinedInput-root': { bgcolor: '#F8FAFB', minHeight: 42 },
      }}
      slotProps={{
        input: {
          startAdornment: <InputAdornment position="start"><SearchRoundedIcon fontSize="small" /></InputAdornment>,
          endAdornment: (
            <InputAdornment position="end">
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.35, px: 0.7, py: 0.25, borderRadius: '12px', bgcolor: 'rgba(20,16,47,.045)', color: 'text.secondary' }}>
                <KeyboardCommandKeyRoundedIcon sx={{ fontSize: 12 }} />
                <Typography variant="caption" sx={{ fontWeight: 700 }}>K</Typography>
              </Box>
            </InputAdornment>
          ),
        },
      }}
    />
  );
};

export const TopBar = ({ onMenuClick }: { onMenuClick?: () => void }) => (
  <Box
    component="header"
    sx={{
      position: 'sticky',
      top: 0,
      zIndex: (t) => t.zIndex.appBar,
      display: 'flex',
      alignItems: 'center',
      gap: 1,
      minHeight: 72,
      px: { xs: 1.25, sm: 2, md: 3 },
      py: 1,
      bgcolor: 'rgba(255,255,255,.88)',
      backdropFilter: 'blur(18px)',
      borderBottom: '1px solid',
      borderColor: 'divider',
      boxShadow: '0 10px 32px -30px rgba(50,27,119,.65)',
    }}
  >
    <IconButton onClick={onMenuClick} sx={{ display: { md: 'none' } }} aria-label="Mở menu">
      <MenuRoundedIcon />
    </IconButton>

    <Box sx={{ flex: 1 }} />

    <QuickSearch />

    <Tooltip title="Không có thông báo mới">
      <IconButton aria-label="Thông báo">
        <Badge color="primary" badgeContent={2} max={9}><NotificationsNoneRoundedIcon /></Badge>
      </IconButton>
    </Tooltip>
    <Tooltip title="Trợ giúp sử dụng hệ thống">
      <IconButton sx={{ display: { xs: 'none', sm: 'inline-flex' } }} aria-label="Trợ giúp"><HelpOutlineRoundedIcon /></IconButton>
    </Tooltip>
  </Box>
);
